module.exports = __webpack_public_path__ + "static/sec5-bg-4f7631855a2958ba6f34542b58e3bd7b.jpg";